import { SELECT_VENUE_ROUTE } from '@constants/routes';

/**
 * Where the native apps launch the webview: their base URL, from the icon or a push notification tap, on Android and
 * iOS. Only a link opens another page.
 */
export const START_PATHNAME = '/';

/** The pages never restored: the start page and the venue picker it redirects to. */
export const UNRESTORED_PATHNAMES = new Set([START_PATHNAME, SELECT_VENUE_ROUTE]);
